import * as api from '../../api/api';
import { Options } from '../../api/api';
import { icons } from '../../webcomponents/exposed-nav/icons';
import { getVehicleHeroImage } from './images';
import { IMenuData, navStore } from '../../webcomponents/exposed-nav/store';


export const getReservation = async () => {
    const { userId }  = navStore.getState() as IMenuData;
    const { origin } = window.location;
    const rsvpUrl = origin + `/mycarmax/api/header/${userId}/reservation`; // MyCarMax BFF

    const options: Options = {
        url: rsvpUrl,
    };
    api.get(
        options,
        function success(res) {
            const image = res?.stockNumber ? getVehicleHeroImage(res.stockNumber) : null;
            const text = res?.stockNumber ? 'My cart' : 'My dashboard';
            if(image){
                setIconContent(image, text);
            }
            requestAnimationFrame(() => {
                clearLoader(res?.stockNumber); // TODO: clearLoader gets executed after the api call resolves but before the image finishes painting
            });
        },
        function error(e) {
            clearLoader(false);
            console.error('Error fetching rsvp data: ', e);
        }
    );
};

export const setIconContent = (icon: string, text: string) => {
    const iconContainer = document.querySelector('#my-dashboard-link > div') as HTMLElement;
    const iconNode = document.createRange().createContextualFragment(icon);
    const iconLabel = document.querySelector('#my-dashboard-link > span') as HTMLElement;


    iconContainer?.appendChild(iconNode);
    iconLabel && (iconLabel.innerText = text);
}

export const clearLoader = (hasVehicleImage: boolean) => {
    const iconContainer = document.getElementById('reservation-loader') as HTMLElement;

    if(iconContainer){
        iconContainer.style.border = 'transparent';

        if (!hasVehicleImage) {
            iconContainer.style.display = 'none';
        }
    }
}
